import { BLANK_PROFILE_PICTURE } from 'constants/defaultConstants';
import { Partner, SocietyDirector } from 'types';

export const getDirectorImage = (
  director: SocietyDirector,
  partners: Partner[]
) => {
  if (director?.image) return director.image;

  const partner = partners?.find((partner) => partner?.cif === director?.cif);

  return partner?.image || BLANK_PROFILE_PICTURE;
};
